import { Spin } from "antd";

export default function LoadingSpinner() {
    return (
        <div className="fullscreen-spinner">
            <Spin size="large" />
        </div>
    )
};